export const colorsComplete: string[] = ['#FF7319','#F3A93F','#61BF7C','#7BABF7'];
export const colorsNotComplete: string[] = ['#FFE3D1','#FDEED9','#DFF2E5','#E5EEFD'];